import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "shared/Alert";
import { listMeetingEmployees } from "features/meetings/api/MeetingsApi";
import { overdueTier, OVERDUE_DAYS } from "features/meetings/ui/meetingUtils";

/** Warning strip on the dashboard: how many employees have never had a meeting or none in the last 90 days. Hidden when none or on error. */
export default function MeetingsOverdueCard() {
  const [never, setNever] = useState(0);
  const [stale, setStale] = useState(0);

  useEffect(() => {
    let cancelled = false;
    listMeetingEmployees()
      .then((rows) => {
        if (cancelled) return;
        setNever(rows.filter((e) => overdueTier(e.last_meeting_date) === "never").length);
        setStale(rows.filter((e) => overdueTier(e.last_meeting_date) === "stale").length);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (never + stale === 0) return null;
  const path = localStorage.getItem("authUserType") === "admin" ? "/admin/meetings" : "/employee/meetings";
  return (
    <Alert tone="warning" role="status" className="text-sm">
      <span data-testid="meetings-overdue-card">
        {never > 0 && <><strong>{never}</strong> {never === 1 ? "employee has" : "employees have"} never had a meeting. </>}
        {stale > 0 && <><strong>{stale}</strong> {stale === 1 ? "employee has" : "employees have"} had no meeting in over {OVERDUE_DAYS} days. </>}
        <Link to={path} className="underline font-medium">Open Employee Meetings</Link>
      </span>
    </Alert>
  );
}
